import { render, staticRenderFns } from "./AbsaAuthScreen.vue?vue&type=template&id=40a7ce2e&scoped=true"
import script from "./AbsaAuthScreen.vue?vue&type=script&lang=js"
export * from "./AbsaAuthScreen.vue?vue&type=script&lang=js"
import style0 from "./AbsaAuthScreen.vue?vue&type=style&index=0&id=40a7ce2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a7ce2e",
  null
  
)

export default component.exports